import { PopDataType } from "@longtail-education/superprep-data-model-frontend"
import { LibrarySelection } from "./library-selection"

export const routeForSelection = (selection: LibrarySelection) => {
  if (!selection.item) { return (selection.section?.subTitle || selection.section?.title?.toLowerCase() === 'your custom units') ? 'collections' : 'subjects'}
  switch (selection.item.dataType) {
    case PopDataType.CategoryTemplate: return 'collections'
    case PopDataType.SubjectTemplate: return 'subjects'
    case PopDataType.GroupTemplate: return 'groups'
    case PopDataType.LevelTemplate: return 'groups'
    case PopDataType.ModuleTemplate: return 'lessons'
    case PopDataType.CardTemplate: return 'cards'
    default: return ('parentCategoryIds' in selection.item) ? 'subjects' : 'library'
  }
}
